/**
 * Where focus goes when the user has moved to another page.
 *
 * A single-page app swaps its content without the browser saying so, so a
 * screen-reader user who pressed "Practices" hears nothing and is left
 * wherever focus was — often on an element that no longer exists. After a
 * real navigation (not a filter, not a tab, not a query string) focus moves
 * to the new page's `h1`, which reads out where they landed; the document
 * title says the same.
 *
 * Two cases are left alone:
 *
 * - **The page placed focus itself.** Focus already inside `<main>` means the
 *   page decided — the practice runner puts it on the question — and moving
 *   it again would undo that.
 * - **Back and Forward** return to a page the user has seen. Focus stays
 *   where the browser left it, so a list keeps its place; only if nothing
 *   holds focus any more is the heading used, so focus is never lost.
 *
 * The heading is focused without scrolling: the router owns scroll position,
 * and restoring it is the part of Back that must not be undone.
 */
export function orientToPage(how) {
    const active = document.activeElement;
    const holdsFocus = active instanceof HTMLElement && active !== document.body && active.isConnected;
    if (holdsFocus && document.querySelector('main')?.contains(active))
        return;
    if (how === 'restored' && holdsFocus)
        return;
    const heading = document.querySelector('h1');
    if (!heading)
        return;
    // Programmatically focusable, and only that: a heading is a place, not a
    // control, so it is never a Tab stop.
    if (!heading.hasAttribute('tabindex'))
        heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
}
//# sourceMappingURL=orientation.js.map